class VideoPlayer extends HTMLElement {
  constructor() {
    super();
    this.videoSrc   = this.getAttribute("data-video")   || "";
    this.posterSrc  = this.getAttribute("data-poster")  || "";
    this.isAutoplay = this.hasAttribute("data-autoplay");
    this.isLoop     = this.hasAttribute("data-loop");
    this.attachShadow({ mode: "open" });
  }

  connectedCallback() {
    this.render();
    this.setupListeners();
  }

  render() {
    // If there's no video src, do not render the play button at all
    const hasVideo = !!this.videoSrc;

    // Decide whether to render the play button (skip if autoplay is enabled)
    const shouldShowPlayButton = hasVideo && !this.isAutoplay;

    // Build any extra video attributes based on data-autoplay & data-loop
    let videoAttributes = "";
    if (this.isAutoplay) {
      // Autoplay on mobile requires muted + playsinline
      videoAttributes += " autoplay muted playsinline";
    }
    if (this.isLoop) {
      videoAttributes += " loop";
    }

    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: block;
          position: relative;
          width: 100%;
          max-width: 1200px;
        }
        .video-container {
          position: relative;
          border-radius: 24px;
          border-bottom-left-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
          overflow: hidden;
          max-height: 401px;
        }
        video {
          width: 100%;
          height: auto;
          display: block;
        }
        @media (max-width: 1023px) {
          .video-container {
            max-height: 480px;
            height: 100vh;
          }
          video {
            object-fit: cover !important;
            width: 100%;
            height: 100%;
            max-height: 480px;
          }
        }
        .play-button {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 80px;
          height: 80px;
          background: rgba(255, 255, 255, 0.8);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: transform 0.3s ease;
        }
        .play-button:hover {
          transform: translate(-50%, -50%) scale(1.1);
        }
        .play-button svg {
          width: 40px;
          height: 40px;
          fill: black;
        }
      </style>

      <div class="video-container">
        <video class="video" poster="${this.posterSrc}"${videoAttributes}>
          <source src="${this.videoSrc}" type="video/mp4">
          Your browser does not support the video tag.
        </video>
        ${
          shouldShowPlayButton
            ? `
            <div class="play-button">
              <svg viewBox="0 0 24 24">
                <path d="M8 5v14l11-7z"/>
              </svg>
            </div>
            `
            : ``
        }
      </div>
    `;
  }

  setupListeners() {
    const video      = this.shadowRoot.querySelector("video");
    const playButton = this.shadowRoot.querySelector(".play-button");

    // If there's no play button (autoplay is on OR no video), skip
    if (!video || !playButton) return;

    playButton.addEventListener("click", () => {
      video.play();
      playButton.style.display = "none";
    });

    video.addEventListener("pause", () => {
      playButton.style.display = "flex";
    });
  }
}

customElements.define("video-player", VideoPlayer);
